import * as Yup from 'yup'
import { Accordion, Form } from 'react-bootstrap'
import { CustomAccordionButton, CustomFormControl } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({});

export const GrantsSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <CustomAccordionButton colors={colors}>Stipendien</CustomAccordionButton>
                    <Accordion.Body>

                        <Form.Group className="mb-3" controlId=''>
                            <Form.Label>Stipendium 1</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder='Stipendium 1'
                                type="text"
                                name='grant1'
                                value={values.grant1}
                                isValid={touched.grant1 && !errors.grant1}
                                isInvalid={errors.grant1}
                                maxLength={settings.textInputLimit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                            </CustomFormControl>
                            <Form.Control.Feedback type="invalid">
                                {errors.grant1}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId=''>
                            <Form.Label>Stipendium 2</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder='Stipendium 2'
                                type="text"
                                name='grant2'
                                value={values.grant2}
                                isValid={touched.grant2 && !errors.grant2}
                                isInvalid={errors.grant2}
                                maxLength={settings.textInputLimit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                            </CustomFormControl>
                            <Form.Control.Feedback type="invalid">
                                {errors.grant2}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId=''>
                            <Form.Label>Stipendium 3</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder='Stipendium 3'
                                type="text"
                                name='grant3'
                                value={values.grant3}
                                isValid={touched.grant3 && !errors.grant3}
                                isInvalid={errors.grant3}
                                maxLength={settings.textInputLimit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                            </CustomFormControl>
                            <Form.Control.Feedback type="invalid">
                                {errors.grant3}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId=''>
                            <Form.Label>Stipendium 4</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder='Stipendium 4'
                                type="text"
                                name='grant4'
                                value={values.grant4}
                                isValid={touched.grant4 && !errors.grant3}
                                isInvalid={errors.grant4}
                                maxLength={settings.textInputLimit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                            </CustomFormControl>
                            <Form.Control.Feedback type="invalid">
                                {errors.grant4}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId=''>
                            <Form.Label>Stipendium 5</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder='Stipendium 5'
                                type="text"
                                name='grant5'
                                value={values.grant5}
                                isValid={touched.grant5 && !errors.grant5}
                                isInvalid={errors.grant5}
                                maxLength={settings.textInputLimit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                            </CustomFormControl>
                            <Form.Control.Feedback type="invalid">
                                {errors.grant5}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};